import type { ExamPaper } from '@/lib/types';

function escapeHtml(input: string): string {
  return input
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

type PrintOptions = {
  useCleaned?: boolean;
  includeAnswer?: boolean;
};

// 등록한 시험지를 다시 인쇄하고, 기입한 답안지도 함께 출력할 수 있어요.
export function printExamPaper(paper: ExamPaper, options: PrintOptions = {}): void {
  const { useCleaned = false, includeAnswer = false } = options;
  const src =
    useCleaned && paper.cleaned_image_url ? paper.cleaned_image_url : paper.image_url;

  // 이미지가 없고 PDF만 있으면 PDF를 새 탭에서 열어 인쇄할 수 있게 해요.
  if (!src && paper.pdf_url) {
    window.open(paper.pdf_url, '_blank');
    return;
  }

  const title = paper.title || '시험지';
  const meta = [paper.school, paper.grade, paper.term, paper.subject]
    .filter(Boolean)
    .join(' · ');
  const answerText = paper.answer ? escapeHtml(paper.answer) : '';

  const imgHtml = src
    ? `<img class="paper" src="${src}" alt="${escapeHtml(title)}" />`
    : '<p class="empty">시험지 이미지가 없습니다.</p>';

  const answerHtml = includeAnswer
    ? `<section class="answer">
         <h2>답안지 (내가 푼 답)</h2>
         ${answerText ? `<pre>${answerText}</pre>` : '<p class="empty">기입한 답안이 없습니다.</p>'}
       </section>`
    : '';

  const html = `<!doctype html>
<html lang="ko">
<head>
<meta charset="utf-8" />
<title>${escapeHtml(title)}</title>
<style>
  * { box-sizing: border-box; }
  body { margin: 0; padding: 24px; font-family: 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif; color: #111; }
  h1 { font-size: 18px; margin: 0 0 4px; }
  .meta { font-size: 12px; color: #555; margin-bottom: 16px; }
  .paper { width: 100%; max-width: 100%; display: block; border: 1px solid #ddd; }
  .empty { color: #888; font-size: 13px; padding: 20px; text-align: center; border: 1px dashed #ccc; }
  .answer { margin-top: 24px; page-break-before: always; }
  .answer h2 { font-size: 15px; margin: 0 0 12px; padding-bottom: 6px; border-bottom: 2px solid #111; }
  .answer pre { white-space: pre-wrap; font-family: inherit; font-size: 14px; line-height: 1.8; margin: 0; }
  @media print { body { padding: 0; } }
</style>
</head>
<body>
  <h1>${escapeHtml(title)}</h1>
  ${meta ? `<div class="meta">${escapeHtml(meta)}</div>` : ''}
  ${imgHtml}
  ${answerHtml}
  <script>
    window.onload = function () {
      setTimeout(function () { window.print(); }, 400);
    };
  </script>
</body>
</html>`;

  const w = window.open('', '_blank');
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
  w.focus();
}